import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { LOGGED_IN_ROUTES } from "../../Constants";
import StepOnePage from "./StepOnePage";
import StepTwoPage from "./StepTwoPage";

import useStyles from "./MulticoteSolutionPage.style";

const MulticoteSolutionPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <Switch>
          <Route path={LOGGED_IN_ROUTES.SOLUTION_FIRST_STEP}>
            <StepOnePage />
          </Route>
          <Route path={LOGGED_IN_ROUTES.SOLUTION_SECOND_STEP}>
            <StepTwoPage />
          </Route>
          <Redirect from="/" to={LOGGED_IN_ROUTES.SOLUTION_FIRST_STEP} />
        </Switch>
      </div>
    </div>
  );
};

export default MulticoteSolutionPage;
